import styled from 'styled-components'
import { media } from '../../utils'

export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  height: 65px;
  margin: 0 auto;
  padding: 0 35px;
  overflow: hidden;

  ${media.largePhone`
    padding: 0 15px;
    .phone-item {
      margin-top: 9px;
      i {
        margin-left: 7.5px;
      }
      p, i {
        letter-spacing: 1px;
        word-spacing: -1.5px;
        font-size: 18px;
      }
    }
  `}
`

export const Logo = styled.div`
  img {
    max-height: 48px;
  }
`



// WEBPACK FOOTER //
// ./src/components/layout/TopNavigationStyle.js